import { observer } from "mobx-react-lite";
import { Link, NavItem } from "@menu/core/types";
import MenuContext from "@menu/core/menu.context";
import { AnalyticsType, getAnalyticTags, getDataTitleTag, gotoUrl } from "@menu/core/lib";
import { useOpenLink } from "@menu/core/hooks";
import imageSrc from "@menu/core/lib/image-src";

type SubNavProps = {
  onBack?: any,
  selectedItem?: NavItem | null,
  context: MenuContext
}

const SubNav = observer((props: SubNavProps) => {
  const { context } = props;
  const openLink = useOpenLink(context);
  const isNewMenu = context.config.useGraphicalMenu;

  if (!context.displaySubMenu || !context.selectedArea || !context.selectedArea.subnavItems) {
    return null;
  }

  const getAnalytics = (link: Link) => {
    return getAnalyticTags({
      component_name: "header_secondary_nav",
      nav_item: AnalyticsType.secondLevel,
      nav_text: link.title,
      target_page_url: link.link
    });
  }

  const onClick = (e: any, link: Link) => {
    openLink(e, link, context)

    if (!context.location) {
      return;
    }

    context.clearArea();
  }

  const { dynamicHeaderSpacing, showAppBanner } = context.config;

  const navCssClass = "sub-menu" + (isNewMenu ? " updated-sub-menu" : "");
  const useDynamicSpacing = showAppBanner || !!dynamicHeaderSpacing;
  const dynamicSpacing = useDynamicSpacing ? " dynamic": "";
  const wrapperCssClass = "sub-menu-wrapper" + dynamicSpacing;
  
  return (
    <div className={wrapperCssClass}>
      <nav className={navCssClass}>
        <ul>
          {context.selectedArea.subnavItems.map((x, ix) => (
            <li
              key={ix}
              onClick={(e) => onClick(e, x)}
              {...getAnalytics(x)}
              {...getDataTitleTag(x.title)}
            >
              {x.title}
            </li>
          ))}
        </ul>
        {isNewMenu && (
          <div className="promotion-banner-container">
            {context.selectedArea.subnavItemsImages?.map((item, index) => (
              <img
                key={index}
                src={imageSrc(item.Image)}
                alt={item.title}
                onClick={() => gotoUrl(item.link, item.openInNewWindow)}
              />
            ))}
          </div>
        )}
      </nav>
    </div>
  );
});

export default SubNav;
